import { getModule } from '@/store/store'
import PageState from './state'
import mutations from './mutations'

const APIS = {
  // 获取生成次数权益
  queryMemberLeftRightApi: 'get /apis/baohuo-account/v1/memberCenter/queryMemberLeftRight',
  // 获取生图权益
  queryGenImgLimitCountApi: `get /apis/baohuo-yuanchuang/intelligent/tool/queryGenImgLimitCount`,
  // 获取风格列表
  getStyleListApi: `get /apis/baohuo-yuanchuang/video/style/page`,
  // 获取比例
  getRatioListApi: `get /apis/baohuo-yuanchuang/video/ratio/list`,
  // 获取效果
  getEffectListApi: `get /apis/baohuo-yuanchuang/video/effect/list`,
  // 生成图片
  generateImageApi: `post /apis/baohuo-yuanchuang/intelligent/tool/generate/text2Img`,
  // 生成黄金开头
  generateGoldStartApi: `post /apis/baohuo-yuanchuang/intelligent/tool/generate/citation`,
  // 生成智能标题
  generateTitleApi: `post /apis/baohuo-yuanchuang/intelligent/tool/generate/title`,
  // 生成智能描述
  generateDescriptionApi: `post /apis/baohuo-yuanchuang/intelligent/tool/generate/desc`,
  // 生成智能改写
  generateRewriteApi: `post /apis/baohuo-yuanchuang/intelligent/tool/generate/rewrite`,
  // 查询生成结果
  getGeneratedResultApi: {
    custom: true,
    url: (data) => `/apis/baohuo-yuanchuang/intelligent/tool/record/detail?recordIds=${ data.recordIds }`,
    method: 'get'
  },
  // 抖音安全检测相关
  checkDouyinTextContent: `post /h5/tt/checkContent`,
  getDouyinAccessToken: `get /h5/tt/getAccessToken`,
}

export default {
  ...getModule({
    name: 'AITools',
    state: new PageState(),
    mutations,
    APIS
  })
}
